<template>
  <a-modal :title="modal.title" v-model="modal.visible" @cancel="handleCancel" :width="900">
    <div style="display:flex">
      <a-input v-model="productName" placeholder="请输入企业名称"></a-input>
      <a-button class="app-btn" style="margin-left:20px" type="primary" @click="doQuery(1)">立即搜索</a-button>
      <a-button class="app-btn" style="margin-left:20px" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
    </div>
    <a-table
      class="mt-5"
      :rowKey="(record, index)=>{return index}"
      bordered
      :loading="tableLoading"
      :columns="tableColumns"
      :dataSource="dataSource"
      @change="handleTableChange$qv"
      :pagination="{
        current: pageNumber,
        pageSize: pageSize,
        total: countTotal,
        showSizeChanger: true,
        showQuickJumper: true,
      }"
    ></a-table>
    <!-- <template slot="footer">
      <a-button @click="handleOk" type="primary">确定</a-button>
    </template> -->
  </a-modal>
</template>

<script>
import { queryViewMixin, toolMixin } from '@/utils/mixin'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        // dataIndex: 'userName',
        customRender: (text, row, index) => {
          return <div>{this.pageSize * (this.pageNumber - 1) + index + 1}</div>
        },
      },
      {
        title: '产品名称',
        align: 'center',
        dataIndex: 'productName',
      },
      {
        title: '状态',
        width: '12%',
        align: 'center',
        dataIndex: 'isOnShelf',
        customRender: text => {
          return <div>{text === 0 ? '已下线' : '已上线'}</div>
        },
      },
      {
        title: '操作',
        width: '10%',
        align: 'center',
        dataIndex: 'detail',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-4 justify-center items-center text-primary-500">
              <a
                onClick={() => {
                  this.copyRow(row)
                }}
              >
                复制
              </a>
            </div>
          )
        },
      },
    ]
    return {
      tableColumns: tableColumns,
      dataSource: [],
      rowKey: 'materialTemplateId',
      productType: '',
      selectedRowKeys: [],
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      productName: null,
      selectedRows: [],
      modal: {
        visible: false,
        title: '选择供应商',
        data: {},
      },
    }
  },
  methods: {
    copyRow(row) {
      this.$emit('end', 'ok', row.productId)
      this.modal.visible = false
    },
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const res = await this.$axios.post('/visa/admin/productTransfer/queryList', {
          data: {
            productName: this.productName,
          },
          pageNumber: _pageNumber,
          pageSize: _pageSize,
        })
        const { number, total, content } = res.data
        this.countTotal = Number(total)
        this.pageNumber = number
        this.dataSource = content
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    getRowSelection(type) {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        columnTitle: '选择',
        columnWidth: 80,
        type: type,
      }
    },
    async start() {
      this.reset$t()
      this.modal.visible = true
      this.doQuery()
      return new Promise((resolve, reject) => {
        this.$once('end', function (state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async handleOk() {
      if (!this.selectedRows.length) {
        return this.$message.error('请选择')
      }
      this.$emit('end', 'ok', this.selectedRows)
    },
    handleCancel() {
      this.$emit('end', 'cancel')
    },
    // async doQuery() {
    //   const { productType } = this
    //   const res = await this.$axios.post('/visa/admin/productMaterialTemplate/queryTemplateByProductType', {
    //     data: { productType },
    //   })
    //   this.dataSource = res.data
    // },
    async removeRow(row) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      await this.$axios.post('/visa/admin/productMaterialTemplate/deleteByTemplateId', {
        data: {
          materialTemplateId: row.materialTemplateId,
        },
      })
      this.$message.success('操作成功!')
      this.doQuery()
    },
  },
}
</script>

<style></style>
